import classes from './popover.module.css'

const Popover = {
  classNames: {
    arrow: classes.arrow,
    dropdown: classes.dropdown,
  },
}

export default Popover
